export default {
    LANGUAGE_DEFAULT: 'en',
    SEARCH_TYPE_FOR_SALE: 'ForSale',
    SEARCH_TYPE_FOR_RENT: 'ForRent',
    SEARCH_TYPE_FOR_RENT_L: 'LongTermRental',
    SEARCH_TYPE_FOR_RENT_S: 'ShortTermRental',

    SEARCH_VERSION_20: '2.0',
    SEARCH_VERSION_21: '2.1',
    SEARCH_VERSION_30: '3.0',
    SEARCH_ENGINE_CORE_API: 'CoreApi',
    SEARCH_ENGINE_RESALES_PLUS: 'ResalesPlus',
    APP_VERSION: process.env.REACT_APP_VERSION_BUILD,

    AUDIT_SYSTEM_TYPE_PROPERTY_VIEWER: 6,
    AUDIT_IMPRESSION_TYPE_PROPERTY_VIEWER: 7,

    AUDIT_ACTION_TYPE_VIEW: 1,

    SEARCH_TYPE_RESALE: 1,
    SEARCH_TYPE_RENTAL_SHORT_TERM: 2,
    SEARCH_TYPE_RENTAL_LONG_TERM: 3,
    SEARCH_TYPE_RENTAL: 4,
    SEARCH_TYPE_RENTAL_REPORT: 5,
    SEARCH_TYPE_DEVELOPMENT: 6,
    SEARCH_TYPE_RESALE_REPORT: 7,
    SEARCH_TYPE_RESALE_AND_DEVELOPMENT: 8,
};
